import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getDirectionsList(axiosPrivate, decisionId) {
	return axiosPrivate
		.get(`${apiURL}/decision/${decisionId}/directions.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function setDirectionsList(axiosPrivate, decisionId, data, cb) {
	console.log("API call - setDirectionsList:", { decisionId, data });
	return axiosPrivate
		.put(`${apiURL}/decision/${parseInt(decisionId)}/directions.json`, data, {
			headers: { "Content-Type": "application/json" },
		})
		.then((res) => {
			console.log("API response - setDirectionsList success:", res);
			if (res.status < 300 && res.status > 199) {
				toast.success("Direction updated");
				cb();
			} else {
				toast.error("Direction failed to update");
			}
			return res;
		})
		.catch((err) => {
			console.error("API error - setDirectionsList:", err.response);
			toast.error("Direction failed to update - " + (err.response?.data?.message || err.message));
			return err.response;
		});
}

export async function getDirectionMembersList(axiosPrivate, searchPhrase) {
	return axiosPrivate
		.get(`${apiURL}/admin/user.json${searchPhrase ? "?phrase=" + searchPhrase : ""}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getDirectionUnitsList(axiosPrivate, searchPhrase) {
	if (searchPhrase) {
		return axiosPrivate
			.get(`${apiURL}/organization-unit/search.json?phrase=${searchPhrase}`)
			.then((res) => {
				if (res.status < 300 && res.status > 199) return res.data;
			})
			.catch((err) => {
				return err.response;
			});
	} else {
		return axiosPrivate
			.get(`${apiURL}/organization-unit.json`)
			.then((res) => {
				if (res.status < 300 && res.status > 199) return res.data;
			})
			.catch((err) => {
				return err.response;
			});
	}
}

export async function getAvailableDecisions(axiosPrivate, searchPhrase) {
	if (searchPhrase) {
		return axiosPrivate
			.get(`${apiURL}/decision/receiver/search.json?phrase=${searchPhrase ? searchPhrase : ""}`)
			.then((res) => {
				if (res.status < 300 && res.status > 199) return res.data;
			})
			.catch((err) => {
				return err.response;
			});
	} else {
		return axiosPrivate
			.get(`${apiURL}/decision/receiver/list.json`)
			.then((res) => {
				if (res.status < 300 && res.status > 199) return res.data;
			})
			.catch((err) => {
				return err.response;
			});
	}
}
